import type { ReactNode } from "react"
import { Navigate } from "react-router-dom"

import { isMobilePhone } from "@/lib/isMobile"

export const DesktopRoute = ({ children }: { children: ReactNode }) => {
  return isMobilePhone ? (
    <Navigate to="/about" replace />
  ) : (
    <>{children}</>
  )
}
